import { styled } from "@mui/material/styles";
import { Box, Stack, Typography } from "@mui/material";

export const StyledHeader = styled(Box)({
  width: "100%",
  height: "auto",
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  zIndex: 0,
});

export const StyledWatermark = styled(Box)({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 0,
  margin: "auto",
  opacity: 0.1,
});

export const StyledPageContent = styled(Stack)({
  zIndex: 1,
  marginTop: "59px",
  padding: "72px",
  gap: "24px",
  height: "100%",
});

export const StyledTitle = styled(Typography)({
  textAlign: "center",
  textDecoration: "underline",
  fontSize: 20,
  fontWeight: 700,
});

export const StyledLabel = styled(Typography)({
  fontSize: 13,
  lineHeight: "18px",
});

export const StyledBoldLabel = styled(Typography)({
  fontSize: 13,
  lineHeight: "18px",
  fontWeight: 700,
});

export const StyledInfoGrid = styled(Stack)({
  display: "grid",
  gridTemplateColumns: "1fr auto",
  gap: "0px",
  width: "100%",
});

export const StyledPricingRow = styled(Stack, {
  shouldForwardProp: (prop) => prop !== "highlight",
})(({ highlight }) => ({
  flexDirection: "row",
  alignItems: "baseline",
  gap: "12px",
  ...(highlight ? { marginTop: "8px" } : {}),
}));

export const StyledDeliveryGrid = styled(Stack)({
  display: "grid",
  gridTemplateColumns: "120px 80px 1fr",
  gap: "4px 16px",
  alignItems: "baseline",
  paddingLeft: "24px",
});

export const StyledGuarantee = styled(Typography)({
  textAlign: "center",
  textDecoration: "underline",
  fontWeight: 700,
  fontStyle: "italic",
  fontSize: 14,
  marginTop: "auto",
  paddingBottom: "24px",
});
